import { render, staticRenderFns } from "./cardloading2.vue?vue&type=template&id=6affd640&scoped=true&"
import script from "./cardloading2.vue?vue&type=script&lang=js&"
export * from "./cardloading2.vue?vue&type=script&lang=js&"
import style0 from "./cardloading2.vue?vue&type=style&index=0&id=6affd640&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affd640",
  null
  
)

export default component.exports